import Vue from 'vue';
import _ from 'underscore';

import Vuex from 'vuex';

import VueResource from 'vue-resource';

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrash, faCheck, faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import VueQrcodeReader from 'vue-qrcode-reader';

import FlagIcon from 'vue-flag-icon';
import 'vue-loading-overlay/dist/vue-loading.css';

export function setup(Vue) {
    Vue.use(Vuex);

    // gives http support
    Vue.use(VueResource);

    // special bootstrap views
    Vue.use(BootstrapVue);

    // font awesome
    library.add(faTrash, faCheck, faTimes, faSearch );
    Vue.component('font-awesome-icon', FontAwesomeIcon);

    // qr code
    Vue.use(VueQrcodeReader);

    // stuff...
    Vue.use(FlagIcon);
}

function prepareEvent(ev) {
    ev.attendees = ev.attendees || [];
    ev.loading = ev.loading || false;
    return ev;
}

function prepareAttendee(at) {
    at.status = at.status || '';
    return at;
}

export function getStore() {
    return new Vuex.Store({
        state: {
            user: {},
            query: '',
            events: {
                list: [],
                loading: false,
            },
        },
        mutations: {
            initUser(state, data) {
                state.user = data;
            },
            searchAttendees(state, query) {
                state.query = query;
            },
            saveEvent(state, data) {
                const event = state.events.list.find(ev => ev._id === data._id);
                if (!event) return state.events.list.push(prepareEvent(data));
                for (let key in data) event[key] = data[key];
                return event;
            },
            deleteEvent(state, id) {
                const event = state.events.list.find(ev => ev._id === id);
                const index = state.events.list.indexOf(event);
                return state.events.list.splice(index, 1);
            },
            setEventLoading(state, loading) {
                state.events.loading = loading;
            },
            fetchEvents(state, events) {
                events.forEach(prepareEvent);
                state.events.list = events;
            },
            uploadList(state, { id, list }) {
                const event = state.events.list.find(ev => ev._id === id);
                if (!event) return;
                list.forEach(prepareAttendee);
                event.attendees.push.apply(event.attendees, list);
            },
            updateAttendee(state, attendee) {
                const event = state.events.list.find(ev => ev._id === attendee.event);
                if (!event) return;
                const prev = event.attendees.find(at => at._id === attendee._id);
                for (let key in attendee) prev[key] = attendee[key];
            },
            setAttendeeLoading(state, { id, loading }) {
                const event = state.events.list.find(ev => ev._id === id);
                if (!event) return;
                event.loading = loading;
            },
            fetchAttendees(state, { id, attendees }) {
                const event = state.events.list.find(ev => ev._id === id);
                attendees.forEach(prepareAttendee);
                event.attendees = attendees;
                event.attendees.loaded = true;
            }
        },
        actions: {
            async fetchEvents({ commit }) {
                commit('setEventLoading', true);
                const res = await Vue.http.get('/api/event/list');
                commit('setEventLoading', false);
                commit('fetchEvents', res.body);
                return res;
            },
            async saveEvent({ commit }, data) {
                // prepare before sending
                data = _.pick(data, '_id', 'title', 'owner', 'date');
                data.id = data._id;
                delete data._id;

                let res;
                if (!data.id) res = await Vue.http.post('/api/event', data);
                else res = await Vue.http.put('/api/event', data);
                commit('saveEvent', res.body);
                return res;
            },
            async deleteEvent({ commit }, data) {
                const res = await Vue.http.delete('/api/event', { body: { id: data._id }});
                commit('deleteEvent', data._id);
                return res;
            },
            async fetchAttendees({ commit }, id) {
                commit('setAttendeeLoading', { id, loading: true });
                const res = await Vue.http.get('/api/attendee/list', { params: { event: id }});
                commit('setAttendeeLoading', { id, loading: false });
                commit('fetchAttendees', { id, attendees: res.body });
                return res;
            },
            async uploadList({ commit }, { id, file }) {
                var formdata = new FormData();
                formdata.append('event', id);
                formdata.append('list', file);

                const res = await Vue.http.post('/api/attendee/list', formdata)
                commit('uploadList', { id, list: res.body });
                return res;
            },
            async updateAttendee({ commit }, attendee) {
                const res = await Vue.http.put('/api/attendee', { id: attendee._id, status: attendee.status });
                commit('updateAttendee', res.body);
                return res;
            }
        },
    });
}